import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dialog",
    "scopeSelect",
    "strategyField",
    "keepDescription",
    "renumberDescription",
    "keepRadio",
    "renumberRadio",
  ]

  static values = {
    originalScope: String,
    hasReports: Boolean,
  }

  connect() {
    this.originalScope = this.originalScopeValue
  }

  submitForm(event) {
    if (!this.hasScopeSelectTarget) return

    const newScope = this.scopeSelectTarget.value

    if (newScope !== this.originalScope && this.hasReportsValue) {
      event.preventDefault()
      this.updateDescriptions(newScope)
      this.keepRadioTarget.checked = true
      this.dialogTarget.showModal()
    }
  }

  updateDescriptions(newScope) {
    const toResource = this.originalScope === "tenant" && newScope === "resource"

    if (this.hasKeepDescriptionTarget) {
      const el = this.keepDescriptionTarget
      el.textContent = toResource ? el.dataset.tenantToResource : el.dataset.resourceToTenant
    }

    if (this.hasRenumberDescriptionTarget) {
      const el = this.renumberDescriptionTarget
      el.textContent = toResource ? el.dataset.tenantToResource : el.dataset.resourceToTenant
    }
  }

  confirm() {
    const selected = this.keepRadioTarget.checked ? "keep_numbers" : "renumber"
    this.strategyFieldTarget.value = selected
    this.dialogTarget.close()

    const form = this.element.querySelector("form")
    if (form) {
      form.requestSubmit()
    }
  }

  cancel() {
    this.scopeSelectTarget.value = this.originalScope
    this.dialogTarget.close()
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.cancel()
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.cancel()
    }
  }
}
